import { Directive, Input, TemplateRef, ViewContainerRef } from '@angular/core';
import { Claim } from '../../client-core/dtos/users.model';
import { UserService } from '../../client-core/services/user.service';

@Directive({
    selector: '[claims]',
    inputs: ['claims']
})
export class ClaimsDirective {
    constructor(
        private templateRef: TemplateRef<any>,
        private viewContainer: ViewContainerRef,
        private userService: UserService) { }

    @Input()
    set claims(requiredClaim: Claim) {

        ///todo: get this from service
        let shouldShow: boolean = false;

        this.userService.getClaims()
            .subscribe(res => {
                console.log('getClaims res', res);
                if (!res.hasError) {
                    let index = res.data.findIndex((claim) => {
                        return claim.resource == requiredClaim.resource && claim.operation == requiredClaim.operation;
                    });

                    if (index >= 0)
                        shouldShow = true;
                }
            }, err => {
                console.log(err);
            }, () => {
                if (shouldShow) {
                    this.viewContainer.createEmbeddedView(this.templateRef);
                } else {
                    this.viewContainer.clear();
                }
            });
    }
}


// WEBPACK FOOTER //
// ./src/app/shared/directives/claims.directive.ts